import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Insurer.List.IRequest;
type Response = Api.Core.Insurer.List.IResponse;
type Headers = Api.Core.Insurer.List.IHeaders;
const url = '/api/ProductManagement/Insurer';
export default async function insurerListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
